<div class="text-center">
  <ng-template #indicatorTemplate>
    <img [src]="icon" [height]="iconSize" [width]="iconSize" />
  </ng-template>

  <nz-spin nzSimple [nzIndicator]="indicatorTemplate"></nz-spin>
  {{ content }}
</div>